// import axios from 'axios'

// const api = axios.create({
//   baseURL: '/api/', // change as needed
//   timeout: 10000,
//   headers: { 'Content-Type': 'application/json' },
// })

// // 🔑 Automatically attach JWT if logged in
// api.interceptors.request.use(config => {
//   const token = localStorage.getItem('token')
//   if (token) config.headers.Authorization = `Bearer ${token}`
//   return config
// })

// export default api
// import axios from 'axios'

// const API_URL = '/api/'

// // Axios instance
// const api = axios.create({
//   baseURL: API_URL,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// })

// // Add Authorization header if token exists
// api.interceptors.request.use(config => {
//   const token = localStorage.getItem('access_token')
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`
//   }
//   return config
// })

// // API endpoints
// export default {
//   // Auth
//   login: (data) => api.post('auth/login/', data),
//   register: (data) => api.post('auth/register/', data),
//   getCurrentUser: () => api.get('users/me/'),

//   // Products
//   getProducts: () => api.get('products/'),
//   createProduct: (data) => api.post('products/', data),
//   updateProduct: (id, data) => api.put(`products/${id}/`, data),
//   deleteProduct: (id) => api.delete(`products/${id}/`),
//   adjustStock: (id, data) => api.post(`products/${id}/adjust_stock/`, data),

//   // Suppliers
//   getSuppliers: () => api.get('suppliers/'),
//   createSupplier: (data) => api.post('suppliers/', data),
//   updateSupplier: (id, data) => api.put(`suppliers/${id}/`, data),
//   deleteSupplier: (id) => api.delete(`suppliers/${id}/`),

//   // Customers
//   getCustomers: () => api.get('customers/'),
//   createCustomer: (data) => api.post('customers/', data),
//   updateCustomer: (id, data) => api.put(`customers/${id}/`, data),
//   deleteCustomer: (id) => api.delete(`customers/${id}/`),

//   // Purchase Orders
//   getPurchaseOrders: () => api.get('purchase-orders/'),
//   createPurchaseOrder: (data) => api.post('purchase-orders/', data),
//   receivePurchaseOrder: (id) => api.post(`purchase-orders/${id}/receive/`),

//   // Sales Orders
//   getSalesOrders: () => api.get('sales-orders/'),
//   createSalesOrder: (data) => api.post('sales-orders/', data),
//   shipSalesOrder: (id) => api.post(`sales-orders/${id}/ship/`),

//   // Stock
//   getStockTransactions: () => api.get('stock-transactions/'),
//   getStockSummary: (params) => api.get('stock-transactions/summary/', { params }),
//   getStockMovements: (params) => api.get('stock-transactions/movements/', { params })
// }
import axios from 'axios'
import { ref } from 'vue'

// Create a preconfigured Axios instance
const api = axios.create({
  baseURL: '/api/', // Django API base URL
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor: attach access token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, (error) => Promise.reject(error))

// Response interceptor: handle 401 Unauthorized
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true

      const refreshToken = localStorage.getItem('refresh_token')
      if (refreshToken) {
        try {
          // Request new access token
          const res = await axios.post('/api/auth/refresh/', {
            refresh: refreshToken
          })
          const newAccessToken = res.data.access
          localStorage.setItem('access_token', newAccessToken)

          // Update the Authorization header and retry the original request
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`
          return api(originalRequest)
        } catch (err) {
          // Refresh token failed, redirect to login if not already there
          localStorage.removeItem('access_token')
          localStorage.removeItem('refresh_token')
          if (window.location.pathname !== '/login') {
            window.location.href = '/login'
          }
          return Promise.reject(err)
        }
      } else {
        if (window.location.pathname !== '/login') {
          window.location.href = '/login'
        }
      }
    }

    return Promise.reject(error)
  }
)

export default api

// append these helpers to the existing api instance (export default api)

// ----- Stock -----
export const getStockSummary = (params) => api.get('/stock/summary/', { params })
export const getStockMovements = (params) => api.get('/stock/movements/', { params })
export const adjustStock = (productId, data) => api.post(`/products/${productId}/adjust_stock/`, data)

// ----- Purchase Orders -----
export const receivePurchaseOrder = (poId, lines) => api.post(`/purchase-orders/${poId}/receive/`, { lines })
export const voidPurchaseOrder    = (poId)        => api.post(`/purchase-orders/${poId}/void/`)

// ----- Sales Orders -----
export const shipSalesOrder   = (soId, lines) => api.post(`/sales-orders/${soId}/ship/`, { lines })
export const returnSalesOrder = (soId)        => api.post(`/sales-orders/${soId}/return_order/`)

// ----- Products -----
export const reconcileProduct = (productId, data) => api.post(`/products/${productId}/reconcile/`, data)

// ----- Users & Roles -----
export const getCurrentUser = () => api.get('/users/me/')
export const getUsers        = (params) => api.get('/users/', { params })
export const createUser      = (data) => api.post('/users/', data)
export const updateUser      = (userId, data) => api.put(`/users/${userId}/`, data)
export const patchUser       = (userId, data) => api.patch(`/users/${userId}/`, data)
export const deleteUser      = (userId) => api.delete(`/users/${userId}/`)
export const getRoles        = () => api.get('/roles/')


// api/axios.js  (or wherever you init api)
const company = ref({})

const fetchCompany = async () => {
  const token = localStorage.getItem('access_token')
  if (!token) return
  const { data } = await api.get('/company/mine/')
  company.value = data
  localStorage.setItem('company', JSON.stringify(data))   // cache
}
// load on boot
const cached = localStorage.getItem('company')
if (cached) company.value = JSON.parse(cached)
else if (localStorage.getItem('access_token')) {
  fetchCompany()
}

export { company }
